module.exports = __webpack_public_path__ + "img/terroir-spiral-4.309074fc.jpg";